import { onMounted, onUnmounted } from 'vue';

export const NAV_SHORTCUTS = {
    h: { path: '/dashboard', label: 'Dashboard' },
    m: { path: '/members', label: 'Members' },
    a: { path: '/accounts', label: 'Bank Accounts' },
    b: { path: '/budget', label: 'Budget' },
    t: { path: '/transactions', label: 'Transactions' },
    r: { path: '/reports', label: 'Reports' },
    d: { path: '/dues', label: 'Dues' },
    i: { path: '/invoices', label: 'Invoices' },
    p: { path: '/profile', label: 'Profile' }
};

export function useKeyboardNav(router, helpVisible) {
    let pendingG = false;
    let pendingTimeout = null;

    function resetPending() {
        pendingG = false;
        if (pendingTimeout) {
            clearTimeout(pendingTimeout);
            pendingTimeout = null;
        }
    }

    function handleKeydown(event) {
        const el = document.activeElement;
        if (el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT' || el.isContentEditable)) {
            return;
        }

        if (event.ctrlKey || event.metaKey || event.altKey) {
            return;
        }

        const key = event.key;

        if (key === '?') {
            helpVisible.value = !helpVisible.value;
            return;
        }

        if (key === 'g' && !pendingG) {
            pendingG = true;
            pendingTimeout = setTimeout(resetPending, 1000);
            return;
        }

        if (pendingG) {
            const shortcut = NAV_SHORTCUTS[key];
            if (shortcut) {
                router.push(shortcut.path);
            }
            resetPending();
        }
    }

    onMounted(() => {
        document.addEventListener('keydown', handleKeydown);
    });

    onUnmounted(() => {
        document.removeEventListener('keydown', handleKeydown);
        resetPending();
    });
}
